import appService from '../../services/appService'
import axiosInstance from '../../plugin/axios'

export const customer = {
  namespaced: true,
  state: {
    lists: [],
    page: {},
    pagination: [],
    show: {},
    temp: {
      temp_id: null,
      isEditing: false
    },
    myOrders: [],
    orderPage: {},
    orderPagination: []
  },
  getters: {
    lists: function (state) {
      return state.lists
    },
    pagination: function (state) {
      return state.pagination
    },
    page: function (state) {
      return state.page
    },
    myOrders: function (state) {
      return state.myOrders
    },
    orderPagination: function (state) {
      return state.orderPagination
    },
    orderPage: function (state) {
      return state.orderPage
    },
    show: function (state) {
      return state.show
    },
    temp: function (state) {
      return state.temp
    }
  },
  actions: {
    lists: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/customer'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url)
          .then((res) => {
            if (typeof payload.vuex === 'undefined' || payload.vuex === true) {
              context.commit('lists', res.data.data)
              context.commit('page', res.data.meta)
              context.commit('pagination', res.data)
            }

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    save: function (context, payload) {
      return new Promise((resolve, reject) => {
        let method = axiosInstance.post
        let url = '/admin/customer'
        if (this.state['customer'].temp.isEditing) {
          method = axiosInstance.post
          url = `/admin/customer/${this.state['customer'].temp.temp_id}`
        }
        method(url, payload.form)
          .then((res) => {
            context.dispatch('lists', payload.search).then().catch()
            context.commit('reset')
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    edit: function (context, payload) {
      context.commit('temp', payload)
    },
    destroy: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .delete(`admin/customer/${payload.id}`)
          .then((res) => {
            context.dispatch('lists', payload.search).then().catch()
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    show: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`admin/customer/show/${payload}`)
          .then((res) => {
            context.commit('show', res.data.data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    reset: function (context) {
      context.commit('reset')
    },

    export: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = 'admin/customer/export'
        if (payload) {
          url = url + appService.requestHandler(payload)
        }
        axiosInstance
          .get(url, { responseType: 'blob' })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    changePassword: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .post(`/admin/customer/change-password/${payload.id}`, payload.form)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    changeImage: function (context, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .post(`/admin/customer/change-image/${payload.id}`, payload.form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            context.commit('show', res.data.data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    myOrders: function (context, payload) {
      return new Promise((resolve, reject) => {
        let url = `admin/customer/my-order/${payload.id}`
        if (payload.search) {
          url = url + appService.requestHandler(payload.search)
        }
        axiosInstance
          .get(url)
          .then((res) => {
            if (typeof payload.vuex === 'undefined' || payload.vuex === true) {
              context.commit('myOrders', res.data.data)
              context.commit('orderPage', res.data.meta)
              context.commit('orderPagination', res.data)
            }

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  mutations: {
    lists: function (state, payload) {
      state.lists = payload
    },
    pagination: function (state, payload) {
      state.pagination = payload
    },
    page: function (state, payload) {
      if (typeof payload !== 'undefined' && payload !== null) {
        state.page = {
          from: payload.from,
          to: payload.to,
          total: payload.total
        }
      }
    },
    myOrders: function (state, payload) {
      state.myOrders = payload
    },
    orderPagination: function (state, payload) {
      state.orderPagination = payload
    },
    orderPage: function (state, payload) {
      if (typeof payload !== 'undefined' && payload !== null) {
        state.orderPage = {
          from: payload.from,
          to: payload.to,
          total: payload.total
        }
      }
    },
    show: function (state, payload) {
      state.show = payload
    },
    temp: function (state, payload) {
      state.temp.temp_id = payload
      state.temp.isEditing = true
    },
    reset: function (state) {
      state.temp.temp_id = null
      state.temp.isEditing = false
    }
  }
}
